import React, { Component } from 'react';
import { Button } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import API_URL from '../../../../common/url';

class Filter extends Component {
    search = () => {
        this.props.search();
    }

    export = () => {
        this.props.export();
    }

    add = () => {
        this.props.add();
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'ba':
            case 'baLeader': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    render () {
        const { searchParams, hasAuth } = this.props;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar">
                    <div className="search-item">
                        <div className="ui-label">BA</div>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.baName}
                            params={{ limit: 20, roleCodes: 'BA,BAL', workStatus: 'ALL' }}
                            url={API_URL.teaching.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={(option) => this.handleChange(option, 'ba')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">BA组长</div>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.baLeaderName}
                            params={{ limit: 20, roleCodes: 'BA,BAL' }}
                            url={API_URL.teaching.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={(option) => this.handleChange(option, 'baLeader')}
                        />
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                        { hasAuth && <Button type="primary" onClick={this.add}>添加</Button> }
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/baGrouping/components/Filter.js